/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'

const AGENCY_REPORT_BASE_LINK = '/admin/agency-reports'

export function getAgencyReportLink (params?: Record<string, unknown>) {
  return AGENCY_REPORT_BASE_LINK + (params ? `?${stringify(params)}` : '')
}
